import { getCss, color as colorUtils, buildSlottedStyles, mediaQueryMax } from '../../utils';

export const createStyles = (): string => {
  const styles = getCss({
    '@global': {
      ':host': {},

      '.table-container': {
        overflowX: 'auto',
      },
    },
  });

  return styles;
};

export const getSlottedCss = (el: HTMLElement): string => {
  return getCss(
    buildSlottedStyles(el, {
      '& table': {
        width: '100%',
        fontFamily: 'Bosch Sans',
        boxSizing: 'border-box',
        borderSpacing: 0,
        borderCollapse: 'collapse',
        backgroundColor: colorUtils.white,

        '& *': {
          boxSizing: 'border-box',
        },

        '& tbody tr': {
          transition: 'background-color 350ms',
          '&:hover': {
            backgroundColor: colorUtils.grey01,
          },
        },

        '& tr': {
          '&.no-padding': {
            '& > th, & > td': {
              height: 'auto',
              padding: '0',
            },
          },

          '&.align-left': {
            textAlign: 'left',
          },

          '&.align-center': {
            textAlign: 'center',
          },

          '&.align-right': {
            textAlign: 'right',
          },
        },

        '& th, & td': {
          minWidth: '80px',
          padding: '12px 1rem',
          fontSize: '14px',
          lineHeight: '24px',
          color: colorUtils.black,

          '&.no-padding': {
            padding: '0',
          },

          '&.align-left': {
            textAlign: 'left',
          },

          '&.align-center': {
            textAlign: 'center',
          },

          '&.align-right': {
            textAlign: 'right',
          },

          [mediaQueryMax('md')]: {
            whiteSpace: 'nowrap',
          },
        },

        '& th': {
          borderTop: `1px solid ${colorUtils.grey05}`,
          borderBottom: `1px solid ${colorUtils.grey05}`,
          fontWeight: 'bold',
          color: colorUtils.darkBlue02,
          textAlign: 'left',
        },

        '& td': {
          borderBottom: `1px solid ${colorUtils.grey02}`,
        },
      },
    })
  );
};
